import { createSelector } from '@/shared/lib/helpers/create-store-logic';

import { initialState } from '../slice/create-histogram-form.slice';

export const [useCreateHistogramForm] = createSelector((state) => state.createHistogramForm ?? initialState);

export const [useSelectedHistogramRedux] = createSelector(
	(state) => state.createHistogramForm?.selectedHistogram ?? '',
);
